import { globalVal } from '../../global/globalvalues';
export const trackOrder: any = {
    inProgressText: "We're getting your Welcome Kit ready.",
    orderShippedText: 'Your Welcome Kit is on the way!',
    bottomText: ` Activate your line within 7 days of getting your Welcome Kit & get the shipping
    charges credited to your ${globalVal.short_name} account.`,
};
